<div class="request__container">
  <div>
    <app-search-bar [viewModel]="searchBarViewModel" (searchEvent)="getRequests(true)"></app-search-bar>
  </div>

  <scc-dsm3-table
    labelBtnAdd="Criar novo pedido"
    labelCount="Pedidos"
    labelExport="Exportar excel"
    [checkLine]="false"
    [columns]="columns"
    [hasBtnAdd]="userService.isProfileRetailer()"
    [hasExport]="true"
    [rows]="viewModel.requests"
    [shadownLine]="false"
    [total]="viewModel.paginationData.total"
    (onClickBtnAdd)="onCreateOrder()"
    (onExport)="onExport()"
    [isClickableRow]="false"
  >
    <scc-dsm3-tbody-column prop="status_label">
      <ng-template let-column="column">
        <app-state-label
          [label]="column.row.status_label"
          [background]="getStateBackgroundColor(column.row.status_label)"
          [color]="getStateTextColor(column.row.status_label)"
        >
        </app-state-label>
      </ng-template>
    </scc-dsm3-tbody-column>

    <scc-dsm3-tbody-column prop="external_status_description">
      <ng-template let-column="column">
        <p class="prop__external_status_description prop__paragraph">{{ column.row.external_status_description }}</p>
      </ng-template>
    </scc-dsm3-tbody-column>

    <scc-dsm3-tbody-column prop="external_identification">
      <ng-template let-column="column">
        <p class="prop__request_type prop__paragraph">{{ column.row.initial_step_title }}</p>
        <a class="prop__contact_id" role="button" tabindex="0" (click)="clickItem(column.row)">
          {{ column.row | dFGUIRequestPropFormat: 'id_request_type' }}
        </a>
      </ng-template>
    </scc-dsm3-tbody-column>

    <scc-dsm3-tbody-column prop="cpe">
      <ng-template let-column="column">
        <p class="prop__cpe prop__paragraph">{{ column.row.cpe }}</p>
      </ng-template>
    </scc-dsm3-tbody-column>

    <scc-dsm3-tbody-column prop="type_step_title">
      <ng-template let-column="column">
        <p class="prop__parent_step_title prop__paragraph">
          {{ column.row.type_step_title }}
        </p>
      </ng-template>
    </scc-dsm3-tbody-column>

    <scc-dsm3-tbody-column prop="step_title">
      <ng-template let-column="column">
        <p class="prop__step_title prop__paragraph">{{ column.row.step_title }}</p>
      </ng-template>
    </scc-dsm3-tbody-column>

    <scc-dsm3-tbody-column prop="created_at">
      <ng-template let-column="column">
        <p class="prop__created_at prop__paragraph">
          {{ column.row | dFGUIRequestPropFormat: 'created_at' | amFromUtc | amLocal | amDateFormat: 'DD/MM/YYYY' }}
        </p>
      </ng-template>
    </scc-dsm3-tbody-column>
  </scc-dsm3-table>

  <scc-dsm3-table-pagination-number
    [currentPage]="viewModel.paginationData.currentPage"
    [defaultOption]="viewModel.paginationData.perPage"
    [options]="pagitionsOptions"
    [perPage]="viewModel.paginationData.perPage"
    [total]="viewModel.paginationData.total"
    (onChange)="onPagination($event)"
  ></scc-dsm3-table-pagination-number>
</div>
